import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import { convertStraight, formatDateTime } from "../../common-data/Converts";
import { fetchApiData } from "../../../redux/reducers/commonApiSlice";
import { leadCountDetails } from "../../../data/ApiEndpoints";
import WatiKeywordCountMobile from "../mobile-uis/WatiKeywordCountMobile";

const WatiKeywordCount = ({ userInfoData, rowData }) => {
  const dispatch = useDispatch();
  const { data, loading } = useSelector((state) => state.common);

  const [isPageLC, setIsPageLC] = useState(0);
  const iniLcFilters = {
    limit: 10,
    page: isPageLC + 1,
    lead_id: rowData?.uid || "",
  };
  const [lcFilters, setLcFilters] = useState(iniLcFilters);
  const iniLeadCounts = {
    leadCountDetails: [],
    leadCountPagination: [],
  };
  const [leadCounts, setLeadCounts] = useState(iniLeadCounts);

  function getLeadCountDetails(lcFilters) {
    dispatch(
      fetchApiData({
        method: "GET",
        endpoint: leadCountDetails,
        payload: {
          filters: lcFilters,
        },
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    if (lcFilters.lead_id) {
      getLeadCountDetails(lcFilters);
    }
  }, [lcFilters]);

  useEffect(() => {
    setLcFilters((prevs) => ({
      ...prevs,
      page: isPageLC + 1,
      lead_id: rowData?.uid || "",
    }));
  }, [rowData?.uid, isPageLC]);

  useEffect(() => {
    if (data?.status && data?.data?.length > 0) {
      setLeadCounts((prevs) => ({
        ...prevs,
        leadCountDetails: data.data,
        leadCountPagination: data.pagination,
      }));
    } else {
      setLeadCounts(iniLeadCounts);
    }
  }, [data]);

  const leadCountsTbColumns = [
    {
      dataField: "gym_name",
      text: "gym name",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.gym_name || "NA"}</span>;
      },
    },
    {
      dataField: "keyword",
      text: "keyword",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.keyword || "NA"}</span>;
      },
    },
    {
      dataField: "source_name",
      text: "source name",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.source_name?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "date",
      text: "Trial Date",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date ? convertStraight(row.date) : ""}
          </span>
        );
      },
    },
    {
      dataField: "preferred_slot",
      text: "preferred slot",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.preferred_slot || "-"}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formatDateTime(row.date_added) : ""}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile">
        {loading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={leadCounts.leadCountDetails}
            tableColumns={leadCountsTbColumns}
            tablePagination={leadCounts.leadCountPagination}
            isPage={isPageLC}
            setIsPage={(value) => setIsPageLC(value)}
          />
        )}
      </div>

      <div className="lead-logs-card-container only-mobile">
        {loading ? (
          <ReactVortoxSpinner />
        ) : (
          <WatiKeywordCountMobile
            tableData={leadCounts.leadCountDetails}
            tablePagination={leadCounts.leadCountPagination}
            isPage={isPageLC}
            setIsPage={(value) => setIsPageLC(value)}
          />
        )}
      </div>
    </>
  );
};

export default WatiKeywordCount;
